/* eslint-disable */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var hasDifferentValues = function hasDifferentValues(field, originalField) {
  return field.value !== originalField.value;
};

exports.default = hasDifferentValues;